import { getTimelineValue } from '@/components/common/Filter/TimelineFilter/utils'
import { CustomReportFiltersParams, UsageCostRequestParams } from '@/hooks'

export const processUsageCostFilters = (
    filters: CustomReportFiltersParams
): UsageCostRequestParams => {
    const { startDate, endDate } =
        'startDate' in filters && 'endDate' in filters
            ? { startDate: filters.startDate, endDate: filters.endDate }
            : getTimelineValue(filters.timeline)

    return {
        'nodeIds[]': filters.nodeIds.join(','),
        commodityTypeId:
            filters.commodityTypeIds?.join(',') ??
            filters.commodityTypeId?.toString(),
        startDate,
        endDate,
        'providerIds[]': filters.providerIds?.join(','),
        'contractIds[]': filters.contractIds?.join(','),
        'panIds[]': filters.panIds?.join(','),
        'tagIds[]': filters.tagIds?.join(','),
        'facilityIds[]': filters.facilityIds?.join(','),
        'usnAccountIds[]': filters.usnAccountIds?.join(','),
        'meterIds[]': filters.meterIds?.join(','),
        unitOfMeasureId: filters.unitOfMeasureId?.toString(),
    }
}
